import { TYPES } from "./types";
import { tkt1OnmDesignService } from "../services"; 

export const getTKT1ONMDesigns = (query) => async (dispatch) => {
  try {
    const result = await tkt1OnmDesignService.getDesigns(query);
    const data = result.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_ONM_DESIGNS_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_ONM_DESIGNS_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const getTKT1ONMDesignByID = (id) => async (dispatch) => {
  try {
    const result = await tkt1OnmDesignService.getDesignByID(id);
    const data = result.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_ONM_DESIGN_BY_ID_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_ONM_DESIGN_BY_ID_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const createTKT1ONMDesign = (designData) => async (dispatch) => {
  try {
    const result = await tkt1OnmDesignService.createDesign(designData);
    const data = result.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_CREATE_TKT1_ONM_DESIGN_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_CREATE_TKT1_ONM_DESIGN_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const updateTKT1ONMDesign = (id, designData) => async (dispatch) => {
  try {
    const result = await tkt1OnmDesignService.updateDesign(id, designData);
    const data = result.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_UPDATE_TKT1_ONM_DESIGN_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_UPDATE_TKT1_ONM_DESIGN_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const deleteTKT1ONMDesign = (id) => async (dispatch) => {
  try {
    const result = await tkt1OnmDesignService.deleteDesign(id);
    
    if (result.data.success) {
      dispatch({
        type: TYPES.ACTION_DELETE_TKT1_ONM_DESIGN_SUCCESS,
        payload: {id},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_DELETE_TKT1_ONM_DESIGN_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const tkt1OnmDesignAction = {
  getTKT1ONMDesigns,
  getTKT1ONMDesignByID,
  createTKT1ONMDesign,
  updateTKT1ONMDesign,
  deleteTKT1ONMDesign
};

